import React, { useState } from "react";
import { Star } from "lucide-react";

/**
 * 0-5 star rating. Interactive by default; pass `readOnly` for display.
 * Clicking the current value again clears it back to 0 (useful for "not rated").
 *
 * Props: value (0-5), onChange(next), readOnly, size (px), max (default 5).
 */
function StarRating({ value = 0, onChange, readOnly = false, size = 22, max = 5 }) {
  const [hover, setHover] = useState(0);
  const active = hover || value;

  return (
    <div className="inline-flex items-center gap-0.5" role="radiogroup">
      {Array.from({ length: max }, (_, i) => i + 1).map((n) => {
        const filled = n <= active;
        return (
          <button
            key={n}
            type="button"
            disabled={readOnly}
            onMouseEnter={() => !readOnly && setHover(n)}
            onMouseLeave={() => !readOnly && setHover(0)}
            onClick={() => !readOnly && onChange?.(value === n ? 0 : n)}
            className={`p-0.5 ${readOnly ? "cursor-default" : "cursor-pointer"} focus:outline-none`}
            aria-label={`${n} star${n > 1 ? "s" : ""}`}
          >
            <Star
              size={size}
              className={filled ? "text-amber-400 fill-amber-400" : "text-gray-300"}
            />
          </button>
        );
      })}
    </div>
  );
}

export default StarRating;
